<template>
  <div class="pageContent wallet" style="position: absolute;">
    <pageTitle title='格林钱包' :showBack = 'false'></pageTitle>
      <div class="table">             
        <div class="raw">
          <div class="col left">
            <div class="inner">
              <router-link to="/wallet/coinDetail">
                <img src="../../../static/wallet/greencoin.png"/>
                <div class="msg">K币<br/><span>{{walletInfo.KCoin}}</span></div>
              </router-link>  
            </div> 
          </div>
          <div class="col">
            <div class="inner">
              <router-link to="/wallet/voucher">
                <img src="../../../static/wallet/voucher.png"/>
                <div class="msg">代金券<br/><span>{{walletInfo.Vouchers}}张</span></div>
              </router-link>    
            </div> 
          </div>
        </div>
        <div class="raw">
          <div class="col left">
            <div class="inner">
              <router-link to="/wallet/VISADetail">
                <img src="../../../static/wallet/visa.png"/>
                <div class="msg">银联<br/><span>￥{{walletInfo.UnionPayCash}}</span></div>
              </router-link>     
            </div>         
          </div>
          <div class="col">
            <div class="inner">
              <router-link to="/wallet/cashDetail">
                <img src="../../../static/wallet/cash.png"/>
                <div class="msg">现金账户<br/><span>￥{{walletInfo.MyCash}}</span></div>
              </router-link>    
            </div> 
          </div>
        </div>           
      </div>
        <div class="cards">
          <mu-list>
              <mu-list-item @click.prevent='goPayPage()'>
                  <mu-avatar :src="require('../../../static/wallet/BarCode.png')" backgroundColor="transparent"  slot="left" :size="22" />
                  <span class='title'>付款码</span>
                  <mu-icon slot="right" value="keyboard_arrow_right"/>
              </mu-list-item>
              <mu-divider />

              <mu-list-item @click.prevent='goValueCrad'>
                  <mu-avatar :src="require('../../../static/wallet/precard.png')" backgroundColor="transparent"  slot="left" :size="22" />
                  <span class='title'>我的储值卡</span>
                  <mu-icon slot="right" value="keyboard_arrow_right"/>
              </mu-list-item>
              <mu-divider />
              <mu-list-item @click.prevent='goMallDeposit'>
                  <mu-avatar :src="require('../../../static/wallet/predeposit.png')" backgroundColor="transparent"  slot="left" :size="22" />
                  <span class='title'>商城预存款</span>
                  <mu-icon slot="right" value="keyboard_arrow_right"/>
              </mu-list-item>
              <mu-divider />
              <mu-list-item @click.prevent='goBankCard'>
                  <mu-avatar src="../../../static/wallet/bankcard.png" backgroundColor="transparent"  slot="left"  :size="22"/>
                  <mu-icon slot="right" value="keyboard_arrow_right"/>
                  <span class='title'>我的银行卡</span>
              </mu-list-item>
          </mu-list>
        </div>
      <div style='height:4.5rem'  v-if="ysfShow">
        <a href="https://www.168.com/mobile/index/index.html"><img style="width:100%;margin-top:20px;" src="../../../static/wallet/mall.jpg" /></a>   
      </div> 
  </div>
</template>
<style lang="less" scoped>
@import "../../assets/theme.less";
.pageContent {
  .table {
    background-color: white;
    width: 100%;
    .raw {
      width: 100%;
      height: 100px;
      border-bottom: 1px solid #f1f1f1;
      .col {
        display: flex;
        display: -webkit-flex;
        margin: 0;
        width: 50%;
        height: 100%;
        float: left;
        .inner {
          margin: auto;
          a {
            color: @primaryBlack;
            img {
              height: 0.55rem;
            }
            .msg {
              color: @secondBlack;
              font-size: 0.26rem;
              display: inline-block;
              height: 40px;
              width: 70px;
              margin-left: 0.7em;
              span {
                font-size: 0.36rem;
                color: black;
              }
            }
          }

          clear: both;
        }
      }
      .left {
        border-right: 1px solid #f1f1f1;
      }
    }
  }
  .cards {
    color: @primaryBlack;
    margin-top: 1em;
    background-color: white;
    .mu-list {
      padding: 0px;
      .title {
        font-size: 0.32rem;
      }
    }
  }
}
</style>
<!--钱包样式-->
<style lang="less">
.wallet {
  background-color: #f5f5f5;
  .title {
    .center {
      text-align: center;
    }
  }
}
.null {
  height: 20px;
}
.clear {
  clear: both;
}
</style>

<script>
import api from "../../api";
import { mapMutations } from "vuex";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // 储值卡开通状态
          ysfShow:true,
    };
  },
  activated() {
    this.GetMyWallet();
    console.log(this.userState);
    var newUrltype = sessionStorage.getItem(window.location.hostname + "_hometype");
    if(newUrltype!=null && newUrltype != undefined && newUrltype!='' && newUrltype.search('ysf')!=-1)
     {
        this.ysfShow = false;
     }
  },
  methods: {
    ...mapMutations({
      setWallet: "setG_walletInfo",
      setState: "setG_userState"
    }),

    // 付款码
    goPayPage() {
      window.location.href = "/apis/UserCenter/GoPayPage";
    },

    // 我的储值卡
    goValueCrad() {
      //debugger;
      if (this.g_UserInfo.HasOpenStoreCard) {
        this.$router.push({ path: "/wallet/valueCardDetail" });
      } 
      else {
        this.$router.push({ path: "/wallet/noValueCard" });
      }
    },
    goMallDeposit() {
      this.$router.push({ path: "/wallet/mallDeposit" });
    },
    goBankCard() {
      this.$router.push({ path: "/wallet/myBankCards" });
    },
    GetMyWallet() {
      this.$http.post(api.GetMyWallet()).then(res => {
        if (res.Result) {
          this.setWallet(res.Data);
        }
        else{
          this.$store.commit("CLEARUSER");
          this.$router.push({ path: "/user/Login" });
        }

      });
    },
    
 
  },
  computed: {
    ...mapGetters({
      walletInfo: "g_walletInfo",
      loginInfo: "g_loginInfo",
      userState: "g_userState",
      g_UserInfo: 'g_UserInfo'
    })
  }
};
</script>


// WEBPACK FOOTER //
// index.vue?d96b647a